import React, { useEffect, useState } from 'react';
import { RouterProvider } from 'react-router-dom';
import { saveCurrentUrl } from '@app/modules/interceptors/NavigationInterceptor';
import initialRoutes from '../handlers/initial-routes';
const AppRouterProvider: React.FC = () => {
  const [isRendered, setIsRendered] = useState(false);
  const [router, setRouter] = useState<RouterProvider>();

  useEffect(() => {
    const fetchRouter = async () => {
      const router = await initialRoutes();
      setRouter(router);
      setIsRendered(true);
    };
    fetchRouter();
  }, []);

  // Save URL on every completed navigation so redirect-after-login always has the latest page
  useEffect(() => {
    if (!router) return;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const unsubscribe = (router as any).subscribe((state: any) => {
      if (state.navigation.state === 'idle') {
        saveCurrentUrl();
      }
    });
    return unsubscribe;
  }, [router]);

  if (!isRendered) {
    return <></>;
  }

  return <RouterProvider router={router} />;
};

export default AppRouterProvider;
